var _g, _g2, _ellipse, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 209,
    viewBox: "0 0 225 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4469_34199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8354 35.2445L39.5086 48.9415M131.795 9.55389L135.467 23.2492",
    stroke: "#D2E3FF",
    strokeWidth: 17.1717,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_4469_34199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9156 196.249C67.9887 199.978 53.6358 191.579 49.8575 177.49L21.8408 73.0177C18.0625 58.9286 26.2895 44.4845 40.2163 40.7559L141.083 13.7513C155.01 10.0228 169.363 18.4217 173.142 32.5108L201.158 136.983C204.937 151.072 196.71 165.516 182.783 169.244L81.9156 196.249Z",
    fill: "#F4F8FF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 112.5,
    cy: 201.03,
    rx: 112.5,
    ry: 7.67742,
    fill: "url(#paint0_radial_4469_34199)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4469_34199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0137 76.2395L158.789 45.2437",
    stroke: "#D2E3FF",
    strokeWidth: 9.24631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_4469_34199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6769 99.99C68.5499 95.7878 71.0455 91.4679 75.252 90.3417L84.391 87.895C88.5976 86.7688 92.9205 89.2632 94.0475 93.4654L96.4963 102.597C97.6232 106.799 95.1276 111.119 90.9211 112.245L81.7821 114.692C77.5756 115.818 73.2526 113.324 72.1257 109.121L69.6769 99.99Z",
    fill: "#D2E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.186 91.0187C102.06 86.8164 104.555 82.4965 108.762 81.3704L117.901 78.9236C122.107 77.7974 126.43 80.2918 127.557 84.4941L130.006 93.6254C131.133 97.8277 128.637 102.148 124.431 103.274L115.292 105.72C111.085 106.847 106.762 104.352 105.635 100.15L103.186 91.0187Z",
    fill: "#D2E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.74 114.852C113.534 115.978 111.038 120.298 112.165 124.5L114.614 133.631C115.741 137.834 120.064 140.328 124.271 139.202L133.41 136.755C137.616 135.629 140.112 131.309 138.985 127.107L136.536 117.976C135.409 113.773 131.086 111.279 126.879 112.405L117.74 114.852Z",
    fill: "#D2E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.675 115.529C144.548 111.327 147.043 107.007 151.25 105.88L160.389 103.434C164.596 102.308 168.919 104.802 170.045 109.004L172.494 118.136C173.621 122.338 171.126 126.658 166.919 127.784L157.78 130.231C153.574 131.357 149.251 128.862 148.124 124.66L145.675 115.529Z",
    fill: "#D2E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.271 72.399C138.065 73.5252 135.569 77.8451 136.696 82.0474L139.145 91.1787C140.272 95.381 144.595 97.8754 148.801 96.7492L157.94 94.3024C162.147 93.1762 164.642 88.8564 163.515 84.6541L161.067 75.5228C159.94 71.3205 155.617 68.8261 151.41 69.9523L142.271 72.399Z",
    fill: "#D2E3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4469_34199",
    x: 25.9257,
    y: -0.354104,
    width: 122.093,
    height: 60.5245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.9627,
    dy: -1.3209
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.102014 0 0 0 0 0.42331 0 0 0 0 0.941667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4469_34199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.3209,
    dy: 2.6418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.27428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.960784 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4469_34199",
    result: "effect2_innerShadow_4469_34199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_4469_34199",
    x: 11.6765,
    y: 5.8667,
    width: 204.93,
    height: 200.513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14.5299,
    dy: -6.60451
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.2953
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.52549 0 0 0 0 1 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4469_34199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.24631,
    dy: 9.24631
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.9565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4469_34199",
    result: "effect2_innerShadow_4469_34199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.385965 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4469_34199",
    result: "effect3_innerShadow_4469_34199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4469_34199",
    x: 34.3887,
    y: 40.6199,
    width: 129.025,
    height: 44.2434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737255 0 0 0 0 0.839216 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4469_34199"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_4469_34199",
    x: 68.0853,
    y: 67.6819,
    width: 106.679,
    height: 74.4322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616407 0 0 0 0 0.731413 0 0 0 0 0.920833 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4469_34199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.3209,
    dy: 2.6418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.27428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4469_34199",
    result: "effect2_innerShadow_4469_34199"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4469_34199",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.5 201.03) scale(84.8517 7.67742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065EEA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentEmpty);
export default __webpack_public_path__ + "static/media/appointment-empty.e4b9ca319ad3d1ad44bb84bfb1224f16.svg";
export { ForwardRef as ReactComponent };